"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitConsentDetails = splitConsentDetails;
/**
 * Split custom "Learn more" consent markdown into ordered sections. A line
 * beginning `## ` starts a new section (its heading); any content before the
 * first such line becomes a leading section with an empty heading. Empty
 * sections are dropped. The result mirrors a registry version's `modalSections`,
 * so custom and default details render identically.
 *
 * This is the single source of truth for the `## ` split rule, shared by the
 * API (candidate config resolution) and the console (live preview) so the
 * author's preview always matches what the candidate is served.
 */
function splitConsentDetails(markdown) {
    const lines = markdown.split('\n');
    const sections = [];
    let current = { heading: '', body: [] };
    for (const line of lines) {
        const match = /^##\s+(.*)$/.exec(line);
        if (match) {
            sections.push(current);
            current = { heading: match[1].trim(), body: [] };
        }
        else {
            current.body.push(line);
        }
    }
    sections.push(current);
    return sections
        .map((s) => ({ heading: s.heading, body: s.body.join('\n').trim() }))
        .filter((s) => s.heading !== '' || s.body !== '');
}
